import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator, signInWithRedirect, signInWithEmailAndPassword, GoogleAuthProvider, getRedirectResult, onAuthStateChanged, signOut, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, collection, getDocs, doc, addDoc, query, where, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID ,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};

console.log('🚀 Firebase initialized with config:', firebaseConfig);
console.log('🌐 Current hostname:', window.location.hostname);

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
const auth = getAuth(firebase);
const database = getFirestore(firebase);

// Connect to emulators IMMEDIATELY before any other operations
if (window.location.hostname.includes("localhost")) {
  console.log('🔧 Connecting to LOCAL emulators...');
  try {
    // Point to the RTDB emulator running on localhost.
    connectFirestoreEmulator(database, 'localhost', 8080);
    connectAuthEmulator(auth, "http://localhost:9100");
    console.log('✅ Connected to Firestore emulator on localhost:8080');
    console.log('✅ Connected to Auth emulator on localhost:9100');
    
    // Verify the connection by checking if we can actually connect
    console.log('🔍 Verifying emulator connection...');
    console.log('🔍 Database app name:', database.app.name);
    console.log('🔍 Database project ID:', database.app.options.projectId);
    console.log('🔍 Auth app name:', auth.app.name);
    console.log('🔍 Auth project ID:', auth.app.options.projectId);
    
    // Test if we can actually write to the emulator
    console.log('🧪 Testing emulator write access...');
    console.log('🧪 Database instance details:');
    console.log('   - Database app name:', database.app.name);
    console.log('   - Database project ID:', database.app.options.projectId);
    console.log('   - Database type:', database.type);
    console.log('   - Database ID:', database._databaseId);
    
    setTimeout(async () => {
      try {
        const testCollection = collection(database, '_test_connection');
        console.log('🧪 Test collection reference:', testCollection);
        console.log('🧪 Test collection path:', testCollection.path);
        console.log('🧪 Test collection firestore instance:', testCollection.firestore);
        console.log('🧪 Test collection firestore database ID:', testCollection.firestore._databaseId);
        
        const testDoc = await addDoc(testCollection, { 
          test: true, 
          timestamp: new Date(),
          message: 'Testing emulator connection'
        });
        console.log('✅ Emulator write test SUCCESSFUL! Document ID:', testDoc.id);
        console.log('✅ Test document reference:', testDoc);
        console.log('✅ Test document path:', testDoc.path);
        console.log('✅ Test document firestore database ID:', testDoc.firestore._databaseId);
        
        // Wait a moment and then try to read it back
        console.log('🧪 Waiting 2 seconds then trying to read test document back...');
        setTimeout(async () => {
          try {
            const readTest = await getDocs(testCollection);
            console.log('📖 Read test collection, found documents:', readTest.size);
            readTest.forEach(doc => {
              console.log('📖 Test document data:', doc.data());
              console.log('📖 Test document firestore database ID:', doc.firestore._databaseId);
            });
          } catch (readError) {
            console.error('❌ Failed to read test document back:', readError);
          }
        }, 2000);
        
        // Clean up the test document
        await deleteDoc(testDoc);
        console.log('✅ Test document cleaned up');
      } catch (testError) {
        console.error('❌ Emulator write test FAILED:', testError);
        console.error('❌ This means the emulator connection is not working!');
      }
    }, 1000);
    
  } catch (error) {
    console.error('❌ Failed to connect to emulators:', error);
    console.error('❌ Falling back to production Firebase!');
  }
} else {
  console.log('⚠️  NOT on localhost - connecting to PRODUCTION Firebase!');
  console.log('⚠️  This means events will be saved to live production database!');
}

console.log('📊 Final database instance:', database);
console.log('🔐 Final auth instance:', auth);

export { 
  firebase, auth, database, 
  signInWithRedirect, GoogleAuthProvider, getRedirectResult, onAuthStateChanged, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail,
  collection, getDocs, doc, addDoc, query, where, updateDoc, deleteDoc, onSnapshot
}